import type { ProjectsWithdrawSearchRequest, ProjectsWithdrawSearchResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertArray, normalizeLimit } from './_utils';

export class SearchWithdrawProjectsUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectsWithdrawSearchRequest): Promise<ProjectsWithdrawSearchResponse> {
    assertArray(command.params, 'params');

    return this.repository.searchWithdrawProjects({
      ...command,
      limit: normalizeLimit(command.limit, 10, 1000),
    });
  }
}


